import {Model} from "./Model";

export class User extends Model {
    first_name;
    last_name;
    email;
    phone;
    sound_effects;
    tutorial;
    points;
    all_points;
    level;
    current_course;
    pending_orders;
    pending_days;
    subscriptions;
    demo;
    multilingual;
    version;
    extra_videos_count;
    extra_videos_new;
}